import { createContext } from 'react';
import { getRealState, getUser } from '@services/Api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

export const UserContext = createContext();

export default function User({ children }) {
  const queryClient = useQueryClient();
  const location = useLocation();

  const {
    data: user,
    isLoading: isLoadingUser,
    refetch: refetch,
  } = useQuery({
    queryKey: ['get-user'],
    queryFn: () => getUser(),
    refetchOnWindowFocus: location.pathname.split('/')[1] != 'login' && true,
  });

  const {
    data: realEstate,
    isLoading: isLoadingRealEstate,
    refetch: refetchRealEstate,
  } = useQuery({
    queryKey: ['get-realestate', 'realState'],
    queryFn: () => (user?.realState ? getRealState(user.realState) : Promise.resolve()),
    enabled: !!user?.realState,
    refetchOnWindowFocus: location.pathname.split('/')[1] != 'login' && true,
  });

  const clearUser = () => {
    queryClient.setQueryData(['get-user'], null);
    queryClient.setQueryData(['get-realestate'], null);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        realEstate,
        refetch: () => {
          refetch();
          refetchRealEstate();
        },
        clearUser,
        isLoading: isLoadingUser || (user && isLoadingRealEstate),
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
